import { useState, useEffect, useCallback } from 'react';

const TESTER_MODE_KEY = 'sp_tester_mode';

let globalListeners = [];
let globalTesterMode = false;

function readStored() {
    try {
        return localStorage.getItem(TESTER_MODE_KEY) === 'true';
    } catch {
        return false;
    }
}

export function useTesterMode() {
    const [isTesterMode, setIsTesterMode] = useState(() => readStored() || globalTesterMode);

    useEffect(() => {
        const enabled = readStored();
        globalTesterMode = enabled;
        setIsTesterMode(enabled);

        const listener = (value) => setIsTesterMode(value);
        globalListeners.push(listener);
        return () => {
            globalListeners = globalListeners.filter((l) => l !== listener);
        };
    }, []);

    const enableTesterMode = useCallback(async () => {
        globalTesterMode = true;
        localStorage.setItem(TESTER_MODE_KEY, 'true');
        globalListeners.forEach((l) => l(true));
    }, []);

    const disableTesterMode = useCallback(async () => {
        globalTesterMode = false;
        localStorage.setItem(TESTER_MODE_KEY, 'false');
        globalListeners.forEach((l) => l(false));
    }, []);

    const toggleTesterMode = useCallback(async () => {
        if (globalTesterMode) await disableTesterMode();
        else await enableTesterMode();
    }, [disableTesterMode, enableTesterMode]);

    return { isTesterMode, enableTesterMode, disableTesterMode, toggleTesterMode };
}
